import * as O from "fp-ts/Option"
import { pipe } from "fp-ts/function"
import { api } from "./api"
import type {
  OrganizationArchiveRequested,
  OrganizationArchiveResponse,
  OrganizationTerminationResponse,
} from "@/types/api"

// Appels API : résiliation de l'organisme, export de ses données.
// Lecture : Admin › Lire. Programmer ou annuler : Admin › Supprimer.
// Demander ou télécharger l'export : Admin › Exporter.

export function getOrganizationTermination(): Promise<OrganizationTerminationResponse> {
  return api.get<OrganizationTerminationResponse>("/organization/termination")
}

/**
 * Programme la résiliation ; le serveur prévient chaque administrateur par e-mail.
 *
 * @example scheduleOrganizationTermination("2026-12-31") // { termination: { effective_on: "2026-12-31", closed: false, ... } }
 */
export function scheduleOrganizationTermination(effectiveOn: string): Promise<OrganizationTerminationResponse> {
  return api.post<OrganizationTerminationResponse>("/organization/termination", { effective_on: effectiveOn })
}

/**
 * Annule une résiliation dont la date d'effet n'est pas passée.
 *
 * @example cancelOrganizationTermination() // Promise<void>, 204 côté serveur
 */
export function cancelOrganizationTermination(): Promise<void> {
  return api.delete<void>("/organization/termination")
}

export function getOrganizationArchive(): Promise<OrganizationArchiveResponse> {
  return api.get<OrganizationArchiveResponse>("/organization/archive")
}

export function requestOrganizationArchive(): Promise<OrganizationArchiveRequested> {
  return api.post<OrganizationArchiveRequested>("/organization/archive")
}

/**
 * Chaque clic obtient un lien signé valable 10 minutes (307).
 * Aucune URL signée stockée : le lien s'ouvre dans un onglet.
 *
 * @example organizationArchiveDownloadUrl("3f2c…") // "/api/v1/organization/archive/3f2c…/download"
 */
// comply-ignore: api-branded-id-types — les services du dépôt prennent des identifiants chaîne.
export function organizationArchiveDownloadUrl(jobId: string): string {
  const base: string = pipe(
    O.fromNullable(import.meta.env.VITE_API_URL),
    O.getOrElse(() => ""),
  )
  return `${base}/api/v1/organization/archive/${encodeURIComponent(jobId)}/download`
}
